import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { FormControl } from '@angular/forms';




import { CpMarketplaceApiService } from '../../services/cp-marketplace-api.service';
import { SharedDataService } from '../../services/shared-data.service';
import { ISSUER_MESSAGES, COMMON_MESSAGES } from 'src/app/messages';
import { SignatoryDetails, SignatoryDoc } from 'appRootPath/models/commercial-papers.model';

@Component({
  selector: 'app-select-signatories',
  templateUrl: './select-signatories.component.html',
  styleUrls: ['./select-signatories.component.scss']
})

export class SelectSignatoriesComponent implements OnInit {

  @Input() modalInputs = {
    type: null, // can be 'issuer', 'investor' or 'ipa'
    cpId: null,
    issueId: null,
    documentsToDisplay: []
  };

  fileTypes = ['.pdf'];
  existingSelectedSignatories = {};
  signatoryListSubjects = {};
  signatoriesLists$ = {};
  signatoriesListModel = {}; // List of signatories returned from the API call.
  searchSignatoryControls = {}; // Each Document name will have a separate FormControl.
  selectedSignatoryList = {};
  allSignatoriesSelected = false;

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: CpMarketplaceApiService,
    private toastr: ToastrService,
    private sharedData: SharedDataService
  ) { }

  ngOnInit() {
    this.apiService.getSignatories(this.modalInputs.cpId).subscribe((resp: SignatoryDoc[]) => {
      if (resp) {
        this.modalInputs.documentsToDisplay.forEach(doc => {
          if (this.modalInputs.cpId) {
            this.signatoriesListModel[doc.docKey] = resp.slice();
          } else {
            this.signatoriesListModel[doc.docKey] = resp[0].signatories.slice();
          }
        });
      }
    });

    if (this.modalInputs.issueId) {
      this.apiService.getPerDocSignatories(this.modalInputs.issueId).subscribe(resp => {
        this.existingSelectedSignatories = resp && resp[0];
      });
    }

    this.modalInputs.documentsToDisplay.forEach(doc => {
      this.selectedSignatoryList[doc.docKey] = [];
    });
  }

  onSignatoryListChange(selectedSignatories, docKey) {
    this.selectedSignatoryList[docKey] = selectedSignatories;
    this.allSignatoriesSelected = Object.keys(this.selectedSignatoryList).reduce((accumulator, currentValue) => {
      return accumulator && !!this.selectedSignatoryList[currentValue].length;
    }, true);
  }

  sendSignatories() {
    const perDocSignatories = { issue: this.modalInputs.issueId };
    const docs = Object.keys(this.selectedSignatoryList);

    docs.forEach(doc => {
      if (this.selectedSignatoryList[doc].length) {
        if (this.modalInputs.type === 'investor' && doc === 'deal_confirmation_note') {
          perDocSignatories[doc] = this.getInvestorDCN();
        } else if (!(this.existingSelectedSignatories && this.existingSelectedSignatories[doc])) {
          perDocSignatories[doc] = this.getSignatoriesObject(this.modalInputs.type, doc);
        } else {
          perDocSignatories[doc] = Object.assign({}, this.existingSelectedSignatories[doc],
            this.getSignatoriesObject(this.modalInputs.type, doc));
        }
      }
    });

    this.apiService.setSelectedSignatories(perDocSignatories).subscribe((resp: any) => {
      if (resp.id) {
        this.toastr.success(ISSUER_MESSAGES.PER_DOC_SIGNATORY_ADDED);
        this.moveState();
      }
    });
  }

  moveState() {
    this.apiService.moveState(this.modalInputs.issueId, { action: 'accept' }).subscribe(res => {
      if (res.status === 'success') {
        this.toastr.success(COMMON_MESSAGES.DOCS_SENT_FOR_SIGNING_ONLY);
        this.activeModal.close(res);
      }
    });
  }

  getInvestorDCN() {
    const investorId = this.sharedData.getUserDataFromLS().user_id;
    if (!this.existingSelectedSignatories) {
      this.existingSelectedSignatories = {};
    }
    if (!this.existingSelectedSignatories['deal_confirmation_note']) {
      return {
        investor: {
          [investorId]: this.simplifySignatures(this.selectedSignatoryList['deal_confirmation_note'])
        }
      };
    } else if (!this.existingSelectedSignatories['deal_confirmation_note'].investor) {
      return Object.assign({}, this.existingSelectedSignatories['deal_confirmation_note'], {
        investor: {
          [investorId]: this.simplifySignatures(this.selectedSignatoryList['deal_confirmation_note'])
        }
      });
    } else {
      const investorDCN = Object.assign({}, this.existingSelectedSignatories['deal_confirmation_note']);
      investorDCN.investor[investorId] = this.simplifySignatures(this.selectedSignatoryList['deal_confirmation_note']);
      return investorDCN;
    }
  }

  getSignatoriesObject(type, doc) {
    return {
      [type]: this.simplifySignatures(this.selectedSignatoryList[doc])
    };
  }

  simplifySignatures(signatures) {
    return signatures.map(signature => {
      return { signatory_id: signature.id, name: signature.name, email: signature.email, designation: signature.designation };
    });
  }

}
